import { useNavigate } from "react-router";
import { BackButtons } from "../../../global/components/Buttons/buttons";
import PageStyle from "./Layout.module.css";

function PageLayout({
  children,
  title,
  action,
  hasBack,
  onClickBack,
  className,
  isMain,
  isHeadLiner,
  support,
  backURL,
  permission,
  goBackCallback,
  hasTopPageDemo = false,
  demoTitle,
}) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Navigate back
    navigate(backURL || -1);

    //navigate(backURL || -1, { state: { preserveState: true } });
    // If a custom goBackCallback is provided, call it
    if (goBackCallback) {
      goBackCallback();
    }
  };

  return (
    <>
      {isHeadLiner === true ? (
        <div className={PageStyle.Route_Buttons}>
          <div>
            <h3 className={PageStyle.Route_Page_Title}>{title}</h3>
            <small className={PageStyle.Route_Page_Support}>{support}</small>
          </div>
          <div>
            {hasBack && <BackButtons onClick={() => navigate(backURL || -1)} />}
          </div>
          {action}
        </div>
      ) : (
        <div>
          {hasTopPageDemo && (
            <div>
              <h3 className={PageStyle.Route_Page_Title}>{demoTitle}</h3>
              <small className={PageStyle.Route_Page_Support}>{support}</small>
            </div>
          )}
          <div className={`${PageStyle.Route_Layout} ${className}`}>
            <div className={PageStyle.Route_Buttons}>
              <div>
                <div>{hasBack && <BackButtons onClick={handleGoBack} />}</div>
                {isMain === true && (
                  <div>
                    <h3 className={PageStyle.Route_Page_Title}>{title}</h3>
                    <small className={PageStyle.Route_Page_Support}>
                      {support}
                    </small>
                  </div>
                )}
              </div>
              {action}
            </div>

            <div className={PageStyle.Route_Page_Layout_Body}>
              {isMain !== true && (
                <div>
                  <h3 className={PageStyle.Route_Page_Title}>{title}</h3>
                </div>
              )}
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PageLayout;
